import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

import { usePreviousWithDefault } from 'shared/lib/usePreviousWithDefault';

import { isRestoredByPersistedStoreSelector, setIsRestoredByPersistedStore } from 'entities/persistedStore';
import { isLoggedSelector } from 'entities/user';

import type { GlobalState } from '../../model/store';

import { PersistedStore } from './PersistedStore';

const globalPersistedStore: { store: PersistedStore | null } = {
  store: null,
};

export const usePersistedStore = (initialReduxState: GlobalState) => {
  const { pathname } = useRouter();
  const isAuth = isLoggedSelector(initialReduxState);
  const previousPathname = usePreviousWithDefault(pathname);

  const persistedStore = useMemo(() => new PersistedStore(initialReduxState, isAuth), [initialReduxState, isAuth]);

  const save = useMemo(() => persistedStore.save.bind(persistedStore), [persistedStore]);

  const { getState, dispatch } = persistedStore.getStore();

  const isRestoredByPersistedStore = isRestoredByPersistedStoreSelector(getState());

  useEffect(() => {
    if (!isRestoredByPersistedStore) {
      return;
    }

    if (previousPathname !== pathname) {
      dispatch(setIsRestoredByPersistedStore(false));
    }
  }, [dispatch, isRestoredByPersistedStore, pathname, previousPathname]);

  useEffect(() => {
    window.addEventListener('pagehide', save);

    return () => window.removeEventListener('pagehide', save);
  }, [save]);

  // Сохраняем экземпляр для доступа из middleware
  useEffect(() => {
    globalPersistedStore.store = persistedStore;
  }, [persistedStore]);

  return persistedStore.getStore();
};

export const getPersistedStoreInstance = () => {
  return globalPersistedStore.store;
};
